import { Icon } from '@chakra-ui/react';
import { useMemo } from 'react';
import { BiCheck, BiX } from 'react-icons/bi';

import { TextCell, TextCellProps } from './TextCell';

export const BooleanCell = (props: Omit<TextCellProps, 'value'> & { value?: boolean; displayFalse?: boolean }) => {
    const { value, textAlign = 'center', displayFalse, ...rest } = props;

    const cellValue = useMemo(() => {
        if (value) {
            return <Icon color={displayFalse ? 'green.400' : undefined} as={BiCheck} />;
        }

        if (displayFalse) {
            return <Icon color="red.400" as={BiX} />;
        }

        return '';
    }, [displayFalse, value]);

    return <TextCell {...rest} value={cellValue} placeholder={null} textAlign={textAlign} />;
};
